import { render, staticRenderFns } from "./TableFieldConfiguratorCell.vue?vue&type=template&id=61ccab44&"
import script from "./TableFieldConfiguratorCell.vue?vue&type=script&lang=js&"
export * from "./TableFieldConfiguratorCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports